/**
 *
 * @param {string} name
 * @returns
 */
export const randomId = (name) => {
	const array = new Uint32Array(10);
	const id = window.crypto.getRandomValues(array)[0];
	return `${name}_${id}`;
};
